<template>
  <div class="container-sm">
    <ol class="options-list-control">
      <li
        v-for="(option, index) in quiz.answers"
        :class="getOptionsClassNames(option)"
        :key="index"
      >
        <a @click="solve(option)">
          {{ option.content }}
        </a>
      </li>
    </ol>
  </div>
</template>

<script>
import OptionsControl from './mixins/OptionsControl';

export default {
  ...OptionsControl,
  name: 'options-list-control',
};
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/components/_typographies';
  @import '@/assets/styles/components/_breakpoints';

  $correct-option-color: #03a9f4 !default;
  $incorrect-option-color: #ff5722 !default;

  .options-list-control {
    list-style: none;
    padding: 0;
    margin: 0 0 16px 0;
    overflow: hidden;
  }

  .options-list-control > li {
    margin-bottom: 8px;

    > a {
      display: block;
      padding: 12px 16px;
      background-color: #fff;
      border: 1px solid rgba(0,0,0,.12);
      border-radius: 4px;
      color: #000;
      cursor: pointer;
      font-size: 20px;
      line-height: 1.65;

      @media (max-width: $tablet-breakpoint - 1) {
        font-size: 24px;
      }
    }

    &.correct > a {
      &,
      &:hover,
      &:active {
        background-color: #fff;
        border-color: $correct-option-color;
        color: $correct-option-color;
      }
    }

    &.incorrect > a {
      &,
      &:hover,
      &:active {
        background-color: #fff;
        border-color: $incorrect-option-color;
        color: $incorrect-option-color;
      }
    }

    &.selected > a {
      border-color: #00c896;
      color: #00c896;
    }

    &.disabled > a {
      background: #eeeeee;
      color: #a7a7a7;
      cursor: no-drop;
    }
  }

  .options-list-control--fixed {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 999;

    background-color: #fff;
    box-shadow: 0 -1px 0 0 rgba(0,0,0,.24);
  }

  .options-list-control--toast {
    padding: 12px 0;
    border-bottom: 1px solid #d9d9d9;
    color: rgba(0,0,0,.54);
    text-align: center;
  }
</style>
